import { Link } from "@tanstack/react-router";
import { Facebook, Linkedin, MapPin, Phone, Mail, Send, Home } from "lucide-react";
import { site } from "@/lib/site";
import logo from "@/assets/ccob-logo.webp";
import logo96 from "@/assets/ccob-logo-96.webp";
import logo192 from "@/assets/ccob-logo-192.webp";

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-24">
      <div className="container-x py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src={logo} srcSet={`${logo96} 96w, ${logo192} 192w, ${logo} 300w`} sizes="96px" alt="CCOB & Company PA" width={300} height={300} className="h-24 w-auto object-contain" />
          <p className="mt-3 text-sm opacity-80 leading-relaxed">
            Trusted CPA firm in Winter Garden delivering accounting, auditing, and tax solutions with three decades of experience.
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <a href={site.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-gold-foreground transition"><Facebook className="h-4 w-4" /></a>
            <a href={site.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-gold-foreground transition"><Linkedin className="h-4 w-4" /></a>
            <a href={site.social.maps} target="_blank" rel="noreferrer" aria-label="Google Maps" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-gold-foreground transition"><MapPin className="h-4 w-4" /></a>
            <a href={site.social.nextdoor} target="_blank" rel="noreferrer" aria-label="Nextdoor" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-gold-foreground transition"><Home className="h-4 w-4" /></a>
          </div>
        </div>

        <div>
          <h2 className="font-display text-lg mb-4">Navigate</h2>
          <ul className="space-y-2 text-sm opacity-90">
            {[
              ["/about","About"],["/services","Services"],["/tax-center","Tax Center"],
              ["/resources","Resources"],["/blog","Blog"],["/reviews","Reviews"],
              ["/cities-we-serve","Service Area"],["/faq","FAQ"],["/contact","Contact"],
              ["/privacy","Privacy Policy"],["/disclaimer","Disclaimer"],["/terms","Terms"],
            ].map(([to,l]) => (
              <li key={to}><Link to={to} className="hover:text-gold transition">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="font-display text-lg mb-4">Contact</h2>
          <ul className="space-y-3 text-sm opacity-90">
            <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 text-gold" /><span>{site.address1}<br/>{site.address2}</span></li>
            <li className="flex gap-2"><Phone className="h-4 w-4 mt-0.5 text-gold" /><a href={`tel:${site.phoneRaw}`}>{site.phone}</a></li>
            <li className="flex gap-2"><Mail className="h-4 w-4 mt-0.5 text-gold" /><Link to="/contact" hash="consultation">Send a secure message</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-lg mb-4">Newsletter</h2>
          <p className="text-sm opacity-80 mb-4">Tax updates, deadlines & financial insights — straight to your inbox.</p>
          <form className="flex gap-2" onSubmit={(e) => {
            e.preventDefault();
            const fd = new FormData(e.currentTarget);
            if (String(fd.get("secondaryPhoneNumber") || "").trim() !== "") return;
          }}>
            <input type="email" required placeholder="Your email" className="flex-1 rounded-full px-4 py-2 bg-white/10 placeholder:text-white/60 border border-white/20 focus:outline-none focus:border-gold text-sm" />
            <input type="text" name="secondaryPhoneNumber" id="secondaryPhoneNumber" autoComplete="off" tabIndex={-1} style={{ display: "none" }} aria-hidden="true" />
            <button className="btn-gold !px-4 !py-2" aria-label="Subscribe"><Send className="h-4 w-4" /></button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs opacity-80">
          <div>© {new Date().getFullYear()} CCOB And Company PA. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/terms" className="hover:text-gold">Terms & Conditions</Link>
            <a href="https://www.puulse.ai/" target="_blank" rel="noreferrer" className="hover:text-gold">Powered by Puulse AI</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
